import { ActionTree } from "vuex";
import { YearmonthsState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<YearmonthsState, RootState> = {};
